import { render, staticRenderFns } from "./QuickLookUpForm.vue?vue&type=template&id=4df33418&scoped=true&"
import script from "./QuickLookUpForm.vue?vue&type=script&lang=js&"
export * from "./QuickLookUpForm.vue?vue&type=script&lang=js&"
import style0 from "./QuickLookUpForm.vue?vue&type=style&index=0&id=4df33418&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df33418",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VForm,VIcon})
